<template>
  <div class="message-list">
    <div class="live">
      <el-row>
        <el-button round type="primary" @click="privateMessage(null,2)">全员消息</el-button>
        <div class="seach-list r iblock">
          <el-select class="input-v"
           v-model="search.status"
           @change="getMessageStatus">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            placeholder="请输入搜索的昵称内容"
            v-model="search.keywords"
            round
            class="input-with-select input-sea r"
          >
            <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
          </el-input>
        </div>
      </el-row>
    </div>
    <!-- //表格数据 -->
    <div class="list-wrap" v-if="resultData.list" v-loading="tableLoading">
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 20px 0;"
      >
        <el-table-column prop="state" label="类型">
           <template slot-scope="scope">
             <span v-show="scope.row.type==1">私人消息</span>
             <span v-show="scope.row.type==2">全员消息</span>
          </template>
        </el-table-column>
        <el-table-column prop="send_user_name" label="发送人"></el-table-column>
        <el-table-column prop="accept_user_name" label="接收人"></el-table-column>
        <el-table-column prop="msg_content" label="消息内容" min-width="180px"></el-table-column>
        <el-table-column prop="updated_at" label="发送时间"></el-table-column>
        <el-table-column prop="status" label="状态">
           <template slot-scope="scope">
            <span v-show="scope.row.state==1">未回复</span>
            <span v-show="scope.row.state==2">已回复</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="privateMessage(scope.row,scope.row.type)">编辑</el-button>
            <el-button type="text" size="mini" @click="recallMessage(reBackMessage(),{id:scope.row.system_msg_id},userMessageList)">撤回</el-button>
          </template>
        </el-table-column>
      </el-table>
        <div class="tc">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>
    </div>
    <!-- 修饰符传参，可以通过子组件的方法更新值的状态或者值 -->
    <PrivateMessage :privateVisible.sync="privateVisible" :private_info="private_info"  :messageType="messageType" :isEdit="true" @uploadStatus="uploadStatus"></PrivateMessage>
  </div>
</template>

<script>
//引入消息组件
import PrivateMessage from './components/private-message'

//引入混合mixins模式
import user_mixins from './components/user-mixins'

import {_userMessageList,_reBackMessage} from '@/api/user-message.js'

export default {
  created() {
    // console.log(this);
    this.userMessageList();
  },
  mixins: [user_mixins],
  components: {
    PrivateMessage
  },
  data() {
    return {
      tableLoading:false,
      search: {
        page: 1,
        size: 10,
        keywords: "",
        status: "0",
      },
      options: [
        {
          label: "全部",
          value: "0"
        },
        {
          label: "私人",
          value: "1"
        },
        {
          label: "全员",
          value: "2"
        }
      ],
      // name type num money date
      resultData: {
      }
    };
  },
  methods: {
    //查询信息
    seachList() {
      this.chearSearchState();
      this.userMessageList();
    },
    getMessageStatus(val){
     if(val){
        this.chearSearchState();
        this.userMessageList();
     }
    },
    allPersonMessage() {
      // this.toLinkBlank("/user/user-personmessage");
    },
    toLinkBlank(path, id) {
      path = id ? `${path}/${id}` : path;
      let routeData = this.$router.resolve({
        path: path
        // params:{userId} //可添加参数
      });
      window.open(routeData.href, "_blank");
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val
      this.userMessageList()
    },
      //子组件成功之后刷新页面
    uploadStatus(val){
      if(val){
        this.userMessageList();
      }
    },
    //撤回消息
    reBackMessage(){
      return _reBackMessage;
    },
    //获取消息列表的内容
    userMessageList(){
      this.tableLoading=true;
      _userMessageList({
        params: {
          page: this.search.page,
          size: this.search.size,
          keywords: this.search.keywords,
          type: this.search.status
        }
      }).then(res => {
        // console.log(res);
        this.tableLoading = false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.message-list {
  .seach-list {
    .input-v {
      // width: 160px;
      margin-left: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
</style>